import React from 'react';
import PropTypes from 'prop-types';

/**
 * SkeletonProfilePicture Component
 * 
 * A circular skeleton for loading profile pictures and avatars.
 * 
 * @param {Object} props
 * @param {string} props.size - Size variant: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl'
 * @param {string} props.className - Additional CSS classes
 * @component
 */
export default function SkeletonProfilePicture({ 
  size = 'base', 
  className = '' 
}) {
  const sizeClasses = {
    xs: 'w-6 h-6',      // 24px
    sm: 'w-8 h-8',      // 32px
    base: 'w-10 h-10',  // 40px
    lg: 'w-12 h-12',    // 48px
    xl: 'w-16 h-16',    // 64px
    '2xl': 'w-20 h-20'  // 80px
  };

  return (
    <div
      className={`bg-gray-200 rounded-full animate-pulse ${sizeClasses[size]} ${className}`}
      aria-label="Loading profile picture"
    />
  );
}

SkeletonProfilePicture.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl', '2xl']),
  className: PropTypes.string,
};